module.exports = __webpack_public_path__ + "img/thumbnail_PronghornAntelope_f_normal.ee0271d0.png";